import React from 'react';
import { Flex } from '@chakra-ui/react';
import { IMyProjectsProps } from './interfaces';
import TopRow from './TopRow';
import MiddleRow from './MiddleRow';
import ImagesRow from './ImagesRow';
import Gallery from './Gallery';
import SanityText from '@components/Shared/SanityText';
import FadeInWhenVisible from '@components/Shared/FadeInWhenVisible/FadeInWhenVisible';

const MyProjects: React.FC<IMyProjectsProps> = ({ project }) => {
  if (!project) return null;

  const {
    topTextRaw,
    topImage,
    properties,
    middleBottomImage,
    middleBottomTextRaw,
    middleTopImage,
    middleTopTextRaw,
    imagesRow,
    bottomTextRaw,
    gallery,
  } = project;

  return (
    <Flex mt="2px" justify="center">
      <Flex direction="column" maxW={1188} w="100%" p="40px">
        <FadeInWhenVisible>
          <TopRow
            topTextRaw={topTextRaw}
            topImage={topImage}
            properties={properties}
          />
        </FadeInWhenVisible>
        <FadeInWhenVisible>
          <MiddleRow
            middleBottomImage={middleBottomImage}
            middleBottomTextRaw={middleBottomTextRaw}
            middleTopImage={middleTopImage}
            middleTopTextRaw={middleTopTextRaw}
          />
        </FadeInWhenVisible>

        <FadeInWhenVisible>
          <ImagesRow imagesRow={imagesRow} />
        </FadeInWhenVisible>

        <FadeInWhenVisible>
          <SanityText content={bottomTextRaw} my={['30px', null, '72px']} />
        </FadeInWhenVisible>

        <FadeInWhenVisible>
          <Gallery gallery={gallery} />
        </FadeInWhenVisible>
      </Flex>
    </Flex>
  );
};

export default MyProjects;
